import { createTheme } from '@mantine/core';

const theme = createTheme({
  fontFamily: '"DM Sans", sans-serif',
  headings: {
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '700',
  },
  primaryColor: 'brand',
  colors: {
    brand: [
      '#f0f9ff', // 0 - Page background
      '#e0f2fe', // 1 - Card hover
      '#bae6fd', // 2 - Progress tracks
      '#7dd3fc', // 3 - Secondary indicators
      '#38BDF8', // 4 - Badges, active
      '#0EA5E9', // 5 - Primary brand
      '#0284C7', // 6 - Gradient end
      '#0369A1', // 7 - Text on light
      '#075985', // 8 - Deep accents
      '#0c4a6e', // 9 - Darkest
    ],
  },
  radius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },
  shadows: {
    xs: '0 1px 2px rgba(0,0,0,0.04)',
    sm: '0 2px 8px rgba(0,0,0,0.06)',
    md: '0 4px 16px rgba(0,0,0,0.08)',
    lg: '0 8px 32px rgba(0,0,0,0.1)',
    xl: '0 16px 48px rgba(0,0,0,0.12)',
  },
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'xl',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
        size: 'lg',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    Container: {
      defaultProps: {
        size: 'xl',
      },
    },
  },
});

export default theme;
